import { render, staticRenderFns } from "./AuthenticationDialog.vue?vue&type=template&id=648497c8&scoped=true"
import script from "./AuthenticationDialog.vue?vue&type=script&lang=js"
export * from "./AuthenticationDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationDialog.vue?vue&type=style&index=0&id=648497c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648497c8",
  null
  
)

export default component.exports